import PercentagePopupIcon from '../../../icons/dataset_percentage_popup.png'
import {IconBox, StyledPercentagePopupImg} from './percentagePopupStyle'

const IconComponent = () => (
  <IconBox>
    <StyledPercentagePopupImg src={PercentagePopupIcon} alt='Percentage Popup Icon' />
  </IconBox>
)

export default IconComponent
